import { schema } from 'normalizr';

export const transaction = new schema.Entity('transaction');
